export default __webpack_public_path__ + "static/menu-do-cf27d33c4c5877aed5176ad5cc197d218f31cad03c36ca51f8b8de389d47efbf.png";